import { useEffect, useState } from "react";
import "./index.scss";
import DevisService from "../../services/devis.service";
import { useAuth } from "../../component/authProvider";

function Dashboard() {
  const [stats, setStats] = useState({
    traite: 0,
    nonTraite: 0,
    thisWeek: 0,
  });

  const { currentUser } = useAuth(); // Assuming you have a way to get the current user
  console.log("🚀 ~ Dashboard ~ currentUser:", currentUser?.userId);
  useEffect(() => {
    async function fetchStats() {
      console.log("Fetching stats for clientId:", currentUser?.userId);
      const data = await DevisService.getStats(currentUser?.userId);
      if (data) {
        setStats(data);
      }
    }
    fetchStats();
  }, [currentUser?.userId]);
  return (
    <div className="dashboard">
      <div className="stats-container">
        <div className="stat-box">
          <h3>Devis traités</h3>
          <p>{stats.traite}</p>
        </div>
        <div className="stat-box">
          <h3>Devis non traités</h3>
          <p>{stats.nonTraite}</p>
        </div>
        <div className="stat-box">
          <h3>Devis créés cette semaine</h3>
          <p>{stats.thisWeek}</p>
        </div>
      </div>
    </div>
  );
}

export default Dashboard;
